const noop = () => {
};
export {
  noop
};
//# sourceMappingURL=noop.js.map
